import React, { useState } from 'react'
import classNames from 'classnames'
import { IconSearch } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { filterHierarchy } from '@/utils/helpers'

import './OrgHierarchySelector.scss'

export const OrgHierarchySelector = ({ currentUserOrgId, userOrgHierarchy }) => {
  const [query, setQuery] = useState('')

  const handleSwitchOrg = (orgID, orgName) => {
    // update local storage
    const user = JSON.parse(localStorage.getItem('User'))
    user.organizationid = orgID
    user.organization_name = orgName
    localStorage.setItem('User', JSON.stringify(user))

    // load the live-listen page (redux will be updated after loading with local storage user)
    // we go to live-listen page instead of just reloading current page since the user may be
    // at a resource they can no longer view from their new org, which causes errors
    window.location.assign('/live-listen')
  }

  const handleUpdateQuery = (event) => {
    setQuery(event.target.value)
  }

  const createHierarchy = (root) => {
    const activeOrg = root && root.organization_id === currentUserOrgId

    return root ? (
      <ul className="org-hierarchy-list" data-testid={`org-hierarchy-list-${root.organization_id}`}>
        <li key={root.organization_id}>
          <Button
            id={root.organization_id}
            onClick={() => {
              if (!activeOrg) {
                handleSwitchOrg(root.organization_id, root.name)
              }
            }}
            className={classNames('org-hierarchy-button', { active: activeOrg })}
          >
            {/* Decoration only — the button is the control, so no nested input here. */}
            <span className={classNames('balto-checkbox radio', { checked: activeOrg })}>
              <span className="balto-checkbox-box" />
            </span>
            {root.name}
          </Button>
          {root?.children && <ul>{root.children.map((child) => createHierarchy(child))}</ul>}
        </li>
      </ul>
    ) : (
      <div className="org-hierarchy-no-results">
        <p className="muted-text">No organizations match the search filter</p>
      </div>
    )
  }

  return (
    <div>
      <div className="search-input mb">
        <input
          data-testid="org-hierarchy-input"
          type="text"
          placeholder="Search organizations..."
          value={query}
          onChange={handleUpdateQuery}
          autoFocus
        />
        <IconSearch />
      </div>
      <div className="org-hierarchy-container">
        <div className="org-hierarchy-scrollable">
          {createHierarchy(filterHierarchy(userOrgHierarchy, query))}
        </div>
      </div>
    </div>
  )
}
